import { useContext } from 'react';

import { MapConfigContext } from '@/contexts/map-config/map-config-context';

export const useMapConfig = () => {
  const context = useContext(MapConfigContext);

  if (!context) {
    throw new Error('useMapConfig must be used within a MapConfigProvider');
  }

  return context;
};
